import { AxiosResponse } from "axios";
import Api from "./Api";

export default {
  getCookie(): Promise<AxiosResponse> {
    return Api.get("/csrf-cookie");
  },
};
